import { Component } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.css'
})
export class FooterComponent {
  socialMedia = [
    {
      icon: 'icofont icofont-social-facebook',
      url:'https://www.facebook.com/profile.php?id=61567504537397'
    },
    {
      icon: 'icofont icofont-social-instagram',
      url:'https://www.instagram.com/consulting_by_mia/'
    },
    {
      icon: 'icofont icofont-social-twitter'
    },
    {
      icon: 'icofont icofont-social-dribble'
    },
    {
      icon: 'icofont icofont-social-linkedin'
    }
  ]
}
